var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Recommendation, RecommendationGroup } from '..';
/**
 * Get AI recommendated item for Aigens member
 * **/
var RecommendationManager = /** @class */ (function () {
    function RecommendationManager() {
        this.debug = false;
    }
    RecommendationManager.prototype.makeItemRecommendations = function (menu, item, member, behavior, type, limit) {
        if (type === void 0) { type = "main"; }
        if (!menu || !item || !behavior)
            return [];
        var itemRelation = menu.itemRelation;
        if (!itemRelation)
            return [];
        var basics = this.makeRecommendations(menu, member, behavior, type, limit);
        var rmap = itemRelation[item.id] || itemRelation[item.backendId];
        var weights = {};
        if (behavior) {
            weights = behavior.weights || {};
        }
        var itemRelationWeight = weights["itemRelation"] || 5;
        this.log("rmap", rmap);
        for (var _i = 0, basics_1 = basics; _i < basics_1.length; _i++) {
            var r = basics_1[_i];
            var targetItem = r.item;
            var weight;
            if (rmap) {
                weight = rmap[targetItem.id] || rmap[targetItem.backendId];
            }
            else {
                var reverse = itemRelation[targetItem.id] || itemRelation[targetItem.backendId];
                if (reverse) {
                    weight = reverse[item.id] || reverse[item.backendId];
                }
                this.log("reverse", reverse);
            }
            if (weight) {
                this.log("weight", targetItem.name, weight);
            }
            else {
                weight = 0;
            }
            var relationScore = weight * itemRelationWeight;
            var reason = {
                type: "itemRelation",
                value: weight,
                score: relationScore
            };
            r.reasons.push(reason);
            r.relationScore = relationScore;
            r.score += relationScore;
        }
        basics.sort(this.compareRecommendation);
        return basics;
    };
    //types, single, main, default main
    RecommendationManager.prototype.makeRecommendations = function (menu, member, behavior, type, limit) {
        if (type === void 0) { type = "main"; }
        if (!menu || !behavior)
            return [];
        this.log("behavior", behavior);
        var likes = this.compileLikes(behavior);
        var result = [];
        var categories;
        if (menu.recommendation) {
            categories = menu.categories.concat(menu.recommendation);
        }
        else {
            categories = menu.categories;
        }
        for (var _i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
            var cat = categories_1[_i];
            if (!cat.groups)
                continue;
            //only consider main items
            var ig = cat.groups[0];
            if (!ig.items)
                continue;
            //if single only, and cat have usb groups, skip
            if ("single" == type && cat.groups.length > 1)
                continue;
            for (var _a = 0, _b = ig.items; _a < _b.length; _a++) {
                var item = _b[_a];
                if ("single" == type && item.groupIds && item.groupIds.length > 1) {
                    //if single only, and item have sub groups, skip
                    continue;
                }
                //free item should not be recommended
                if (item.price <= 1) {
                    this.log("skipping no price", item);
                    continue;
                }
                var r = this.calculateScore(member, behavior, item, likes);
                r.category = cat;
                r.itemgroup = ig;
                r.item = item;
                result.push(r);
            }
        }
        result.sort(this.compareRecommendation);
        this.log("low level recom sorted", result);
        if (limit && result.length > limit) {
            result.splice(limit);
        }
        return result;
    };
    RecommendationManager.prototype.compileLikes = function (behavior) {
        var likes = {};
        if (!behavior)
            return likes;
        for (var key in behavior) {
            if ('weights' != key) {
                this.addLikes(likes, behavior[key]);
            }
        }
        //this.log("likes2", likes);
        return likes;
    };
    //types, single, main, default main
    RecommendationManager.prototype.sortItems = function (items, member, behavior) {
        //this.log("behavior", behavior);
        if (member === void 0) { member = null; }
        if (behavior === void 0) { behavior = null; }
        var likes = this.compileLikes(behavior);
        var result = [];
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var r = this.calculateScore(member, behavior, item, likes);
            r.item = item;
            result.push(r);
        }
        result.sort(this.compareRecommendation);
        var sorted = result.map(function (r) { return r.item; });
        //this.log("sort results", sorted);
        return sorted;
    };
    RecommendationManager.prototype.groupRecommendations = function (recs, sort) {
        if (sort === void 0) { sort = "full"; }
        var map = {};
        for (var _i = 0, recs_1 = recs; _i < recs_1.length; _i++) {
            var rec = recs_1[_i];
            var item = rec.item;
            var cleanName = this.cleanName(item.name);
            var prefId = rec.item['preferenceId'];
            if (!prefId) {
                prefId = cleanName;
            }
            var prefg = map[prefId];
            if (!prefg) {
                prefg = new RecommendationGroup();
                prefg.name = cleanName;
                prefg.preferenceId = prefId;
                prefg.recommendations = [];
                prefg.scores = {};
                map[prefId] = prefg;
            }
            prefg.recommendations.push(rec);
            this.setIfHigher(prefg.scores, "full", rec.score);
            var featuredScore = rec.featuredScore;
            if (!featuredScore)
                featuredScore = 0;
            var finalScore = rec.score + featuredScore * 100;
            this.setIfHigher(prefg.scores, "featuredFull", finalScore);
            for (var _a = 0, _b = rec.reasons; _a < _b.length; _a++) {
                var reason = _b[_a];
                this.setIfHigher(prefg.scores, reason.type, reason.score);
            }
        }
        var result = [];
        for (var key in map) {
            result.push(map[key]);
        }
        if (sort == 'full') {
            sort = 'featuredFull';
        }
        result = this.sortRecommendationGroups(result, sort);
        this.log("rec groups", result);
        return result;
    };
    RecommendationManager.prototype.sortRecommendationGroups = function (rgroups, sort) {
        //this.log("sorting by", sort);
        if (!rgroups || rgroups.length == 0)
            return [];
        var result = rgroups.slice();
        result.sort(function (a, b) { return (a.scores[sort] > b.scores[sort]) ? -1 : ((b.scores[sort] > a.scores[sort]) ? 1 : 0); });
        return result;
    };
    RecommendationManager.prototype.addLikes = function (likes, segments) {
        if (!segments)
            return;
        for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
            var s = segments_1[_i];
            s.options = segments.length;
            likes[s.name] = s;
        }
    };
    RecommendationManager.prototype.calculateScore = function (member, behavior, item, likes) {
        if (likes === void 0) { likes = {}; }
        var rating = item.rating;
        if (!rating)
            rating = 2.5;
        var popularity = item.popularity;
        if (!popularity)
            popularity = 2.5;
        var segmentScore = 0;
        var ratingScore = 0;
        var popularityScore = 0;
        var aiValue = 0;
        var reasons = [];
        var segments = [];
        if (item.segments) {
            for (var _i = 0, _a = item.segments; _i < _a.length; _i++) {
                var seg = _a[_i];
                var profile = likes[seg];
                if (profile) {
                    var intensity = profile.intensity;
                    if (intensity) {
                        segmentScore += intensity / 100;
                        segments.push(seg);
                    }
                    var prop = profile.prop;
                    if (prop) {
                        //we want the score value to max at 5
                        aiValue += prop / 20;
                    }
                    else {
                        //if propbability is not defined, we assumed the base line prob, which is 100 divide by number of options
                        prop = 100 / profile.options;
                        aiValue += prop / 20;
                    }
                }
            }
            //take the average?
            aiValue = aiValue / item.segments.length;
        }
        //need to weight the segment scores, because this will favor food with many segments too much
        var segmentCount = segments.length;
        if (segmentCount > 0) {
            var segmentWeight = 1 + ((segmentCount - 1) / 10);
            segmentScore = (segmentScore / segmentCount) * segmentWeight;
        }
        var weights = {};
        if (behavior) {
            weights = behavior.weights || {};
        }
        var prefWeight = weights["preference"] || 0.3;
        var ratingWeight = weights["rating"] || 0.4;
        var popularWeight = weights["popularity"] || 0.3;
        var autoWeight = weights["auto"] || 0.3;
        var pref = segmentScore * 5.0;
        var prefScore = pref * prefWeight;
        reasons.push({
            type: "preference",
            value: segments,
            score: prefScore
        });
        ratingScore = rating * ratingWeight;
        reasons.push({
            type: "rating",
            value: rating,
            score: ratingScore
        });
        popularityScore = popularity * popularWeight;
        reasons.push({
            type: "popularity",
            value: popularity,
            score: popularityScore
        });
        var aiScore = aiValue * autoWeight;
        reasons.push({
            type: "ai",
            value: aiValue,
            score: aiScore
        });
        var result = new Recommendation();
        var featuredScore = item.featuredRating;
        if (featuredScore && this.shouldFeatured(member, item)) {
            result.featuredScore = featuredScore;
            reasons.push({
                type: "featured",
                value: featuredScore,
                score: featuredScore
            });
        }
        result.score = prefScore + ratingScore + popularityScore + aiScore;
        result.reasons = reasons;
        return result;
    };
    RecommendationManager.prototype.compareRecommendation = function (a, b) {
        var fs1 = a.featuredScore ? a.featuredScore : 0;
        var fs2 = b.featuredScore ? b.featuredScore : 0;
        if (fs1 || fs2) {
            return (fs1 > fs2) ? -1 : ((fs2 > fs1) ? 1 : 0);
        }
        return (a.score > b.score) ? -1 : ((b.score > a.score) ? 1 : 0);
    };
    RecommendationManager.prototype.shouldFeatured = function (member, item) {
        if (!item.featuredUsers || item.featuredRating == 0)
            return false;
        if (member && member.id > 10 && item.featuredUsers.indexOf('member') >= 0) {
            return true;
        }
        else if (!member && item.featuredUsers.indexOf('guest') >= 0) {
            return true;
        }
        return false;
    };
    RecommendationManager.prototype.setIfHigher = function (scores, type, value) {
        var existing = scores[type];
        if (!existing || value > existing) {
            scores[type] = value;
        }
    };
    RecommendationManager.prototype.cleanName = function (name) {
        var result = name.replace(/ *\([^)]*\) */g, "");
        return result;
    };
    RecommendationManager.prototype.log = function (tag) {
        var others = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            others[_i - 1] = arguments[_i];
        }
        if (!this.debug)
            return;
        console.log(tag, others);
    };
    RecommendationManager = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], RecommendationManager);
    return RecommendationManager;
}());
export { RecommendationManager };
//# sourceMappingURL=recommendation-manager.js.map